import * as React from 'react';
import classNames from 'classnames';
import {NOOP} from '../utilities';
import styles from './Card.scss';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface CardProps extends DivElementProps {
  imageUrl?: string;
  imageAlt?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler;
}

export function Card({imageUrl, imageAlt, children, onClick = NOOP, ...restProps}: CardProps) {
  return (
    <div className={styles.card} onClick={onClick} {...restProps}>
      {imageUrl && <img className={styles.image} src={imageUrl} alt={imageAlt || ''} />}
      <div className={classNames(styles.cardContent, imageUrl && styles.noBorderTop)}>
        {children}
      </div>
    </div>
  );
}
